export default {
  text1: '堂',
  text2: '%',
  text3: '套',
  text4: '次',
  text5: '分钟',
  text6: '则',
  text7: '人',
  text8: 'm',
}